import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import WordleEventsCreate from './components/WordleEventsCreate';
import WordleEventsEdit from './components/WordleEventsEdit';
import WordleEventsList from './components/WordleEventsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.HUNGARY, APP_TYPES.IRELAND],
  allowedRoles: [roles.ADMIN],
  label: 'Wordle Events',
  subMenuName: 'dailyGames',
};

export default {
  create: WordleEventsCreate,
  list: WordleEventsList,
  edit: WordleEventsEdit,
  icon: EmojiObjectsIcon,
  name: 'admin/wordle',
  options,
};
